import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  allDesignation,
  allQualification,
  allSpecialization,
  allRelevant_Training,
  allUsers,
  AllTrainingField,
  AllTrainingStatus,
  AllTrainingType,
} from "../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  Update,
  GetAll,
  GetByUserId,
} from "../../../../../../../features/admin/quality_management/resource_requirement/training_details/Slice";

import { formatDateForInput } from "../../../../../../../utils/common";

function Raised_Training_Edit_Offcanvas({ show, handleClose, id }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const all_designation = useSelector((state) => state.common.all_designation);
  const all_qualification = useSelector(
    (state) => state.common.all_qualification,
  );
  const all_specialization = useSelector(
    (state) => state.common.all_specialization,
  );
  const all_relevant_training = useSelector(
    (state) => state.common.all_relevant_training,
  );
  const authdetails = useSelector((state) => state.auth);

  const all_users = useSelector((state) => state.common.all_users);

  const isAdmin = authdetails?.role_id === 1;

  const all_training_field = useSelector(
      (state) => state.common.all_training_field,
    );
    const all_training_status = useSelector(
      (state) => state.common.all_training_status,
    );
  
    const all_training_type = useSelector(
      (state) => state.common.all_training_type,
    );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(allDesignation());
    dispatch(allQualification());
    dispatch(allSpecialization());
    dispatch(allRelevant_Training());
    dispatch(allUsers());
    dispatch(AllTrainingField());
    dispatch(AllTrainingStatus());
    dispatch(AllTrainingType());
    //dispatch(GETAuthLogin());
  }, [dispatch]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.data;

        //map ID → label
        const designation = all_designation?.find(
          (o) => o.value === data.designation_id,
        )?.label;

        const qualification = all_qualification?.find(
          (o) => o.value === data.qualification_id,
        )?.label;

        const specialization = all_specialization?.find(
          (o) => o.value === data.specialization_id,
        )?.label;

        const relTraining = all_relevant_training?.find(
          (o) => o.value === data.relevant_training_id,
        )?.label;

        const TrainingField = all_training_field?.find(
          (o) => o.value === data.training_field_id,
        )?.label;

        const TrainingStatus = all_training_status?.find(
          (o) => o.value === data.relevant_training_id,
        )?.label;

        const TrainingType = all_training_type?.find(
          (o) => o.value === data.type_of_training_id,
        )?.label;

        const user = data?.User || {};

        reset({
          name: user?.name || "",
          contact_no: user?.contact_no || "",
          email: user?.email || "",
          training_field_id: data.training_field_id || null,
          type_of_training_id: data.type_of_training_id || null,
          duration: data.duration || null,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && id) {
      GetData(id);
    }
  }, [show, id]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {

    console.log("Raised Training", data);
    
    try {
      const sendData = new FormData();

      //options
      sendData.append("training_field_id", data.training_field_id);
      sendData.append("type_of_training_id", data.type_of_training_id);
      sendData.append("duration", data.duration);


      const res = await dispatch(Update({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAll());

        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("degree", null);
    setRemovedFiles((prev) =>
      prev.includes("degree") ? prev : [...prev, "degree"],
    );
  };

  const handleRemoveAttach = () => {
    setAttachPreview(null);
    setValue("training_certificate", null);
    setRemovedFiles((prev) =>
      prev.includes("training_certificate")
        ? prev
        : [...prev, "training_certificate"],
    );
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Training Details
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    {...register("name", {
                      required: "Personal name is required",
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Contact No</Form.Label>
                  <Form.Control
                    {...register("contact_no", {
                      required: "Personal Contact No. is required",
                    })}
                  />
                  {errors.contact_no && (
                    <span className="text-danger">
                      {errors.contact_no.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    {...register("email", {
                      required: "Personnel Email is required",
                    })}
                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </Form.Group>
              </div>


              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Type Of Training</Form.Label>
                  <Controller
                    name="type_of_training_id"
                    control={control}
                    rules={{ required: "Type of Training is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_training_type}
                        value={
                          all_training_type?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.type_of_training_id && (
                    <span className="text-danger">
                      {errors.type_of_training_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Training Field</Form.Label>
                  <Controller
                    name="training_field_id"
                    control={control}
                    rules={{ required: "Training Field is required" }}
                    render={({ field }) => (
                      <Select
                        options={all_training_field}
                        value={
                          all_training_field?.find(
                            (o) => o.value === field.value,
                          ) || null
                        }
                        onChange={(e) => field.onChange(e?.value || null)}
                      />
                    )}
                  />
                  {errors.training_field_id && (
                    <span className="text-danger">
                      {errors.training_field_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>


              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Duration</Form.Label>
                  <Form.Control
                    {...register("duration", {
                      required: "Training Duration is required",
                    })}
                  />
                  {errors.duration && (
                    <span className="text-danger">{errors.duration.message}</span>
                  )}
                </Form.Group>
              </div>

              



            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Raised_Training_Edit_Offcanvas;
